import React from 'react'
import { ICommonProps, IComponent, IDefaultStyles } from '../schemamanager/types'
import { ElementProps } from '../base/element'
import { IError } from '../schemamanager/schemaManager'

export interface IErrorPanelComponent extends ICommonProps {
  type: 'errorpanel'
  label?: string
}

export const Errorpanel = (props: ElementProps) => {
  const { sm, events } = props
  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'mx-2 my-6 px-4 py-4',
        borderRadius: 'rounded-sm',
        boxShadow: 'shadow-md',
        backgroundColor: 'bg-gray-100'
      }
    },
    styleLabel: {
      classes: {
        margin: 'mb-2',
        fontSize: 'text-xl',
        fontWeight: 'font-bold',
      }
    },
    styleError: {
      classes: {
        margin: 'my-1',  
      }
    },
    styleErrorField: {
      classes: {
        margin: 'ml-2',
        padding: 'px-2',
        fontWeight: 'font-bold',
        cursor: 'cursor-pointer',
        backgroundColor: 'bg-gray-200',
        borderRadius: 'rounded',
        boxShadow: 'shadow-lg',
      }
    },
    styleErrorLabel: {
      classes: {
        margin: 'ml-2',  
        textColor: 'text-red-400'
      }
    }
  }

  const comp = props.comp as IErrorPanelComponent
  const m = props.mergeStyles(style)
  if (sm.Errors.length === 0) return null
  const getErrorLabel = (e: IError) => {
      let lb = sm.getCompLabel(e.comp as IComponent)
      if (typeof e.arrayInd !== 'undefined' && e.arrayInd > -1 && e.comp) {
         const dt = sm.getParentDataTable(e.comp)  
         if (dt) {
            lb =  sm.getCompLabel(dt as IComponent) + '[' + (e.arrayInd + 1) + '].' + lb
         }
      }
      return lb
  }

  const onErrorClick = (e: IError) => {
      if (e.comp) {
          const arrayInd = typeof e.arrayInd !== 'undefined' ? e.arrayInd : -1
          sm.FocusComponent(e.comp as IComponent, arrayInd)
      }

  }

  return (
    <div {...m.main} {...events()}>
      {comp.label && <div {...m.styleLabel}> {comp.label}</div>}
      {sm.Errors.map((e) => (
        <div {...m.styleError} ><span {...m.styleErrorField} onClick={() => onErrorClick(e)}>{getErrorLabel(e)}</span>  <span {...m.styleErrorLabel}>{e.error}</span></div>
      ))}
    </div>
  )
}
